import * as mapper from '../utils/mapper.js'
export function toText(value, type) {
  const enumTypeText = mapper[type]
  if (!enumTypeText) {
    return ''
  }
  value = value || ''
  const result = enumTypeText.find(obj => {
    return obj.value === value
  })
  return result && result.text
}
  const filters = {
    toText
  }

  export default filters


// WEBPACK FOOTER //
// ./src/utils/filters.js